import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取商学院(分类)列表
export const getGory = params => {
    return get(`/admin/college/category`, params);
};
// 新增商学院(分类)
export const addGory = params => {
    return post("/admin/college/category", params);
};
// 修改商学院(分类)信息
export const editGory = params => {
    return put(`/admin/college/category/${params.id}`, params);
};
// 删除商学院(分类)
export const deleteGory = params => {
    return del(`/admin/college/category/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/caGory.js